export default __webpack_public_path__ + "static/media/Insert_Text_Backspace.fbfe922a.svg";